import { render, staticRenderFns } from "./CrudOrganizationMembers.vue?vue&type=template&id=5a1c27a8&"
import script from "./CrudOrganizationMembers.vue?vue&type=script&lang=js&"
export * from "./CrudOrganizationMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports